// styles.js - Arquivo de estilos para o clone do Freshdesk

const styles = {
  container: {
    backgroundColor: "#f5f7f9",
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  contentWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "24px",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: "16px",
  },
  tabContainer: {
    marginBottom: "24px",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  tabRow: {
    display: "flex",
    alignItems: "center",
  },
  tabLabel: {
    marginRight: "16px",
    color: "#4a5568",
  },
  tabsWrapper: {
    display: "flex",
  },
  tabButton: {
    padding: "12px 16px",
    color: "#718096",
    border: "none",
    background: "none",
    cursor: "pointer",
    fontSize: "14px",
    textAlign: "center",
    position: "relative",
    outline: "none", // Remove o outline ao clicar
    WebkitTapHighlightColor: "transparent",
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none",
    boxShadow: "none",
    borderBottom: "2px solid transparent", // Linha base transparente
  },
  activeTabButton: {
    color: "#3182ce",
    borderBottom: "2px solid #3182ce",
  },
  tabCount: {
    marginLeft: "8px",
    backgroundColor: "#edf2f7",
    color: "#4a5568",
    padding: "2px 8px",
    borderRadius: "9999px",
    fontSize: "12px",
  },
  searchBar: {
    position: "relative",
  },
  searchBarWrapper: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #e2e8f0",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  searchInput: {
    padding: "8px 16px",
    width: "250px",
    border: "none",
    outline: "none",
    fontSize: "14px",
  },
  searchButton: {
    padding: "8px",
    backgroundColor: "transparent",
    border: "none",
    color: "#718096",
    cursor: "pointer",
    outline: "none", // Remove o outline ao clicar
  },
  infoText: {
    fontSize: "14px",
    color: "#4a5568",
    marginBottom: "16px",
  },
  moreInfoButton: {
    marginLeft: "4px",
    border: "none",
    background: "none",
    color: "#3182ce",
    fontSize: "14px",
    cursor: "pointer",
    outline: "none", // Remove o outline ao clicar
  },
  actionsRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    marginBottom: "24px",
  },
  modelsButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "8px 16px",
    border: "1px solid #e2e8f0",
    borderRadius: "4px",
    color: "#4a5568",
    backgroundColor: "#fff",
    cursor: "pointer",
    outline: "none", // Remove o outline ao clicar
  },
  newRuleButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "8px 16px",
    borderRadius: "4px",
    color: "#fff",
    backgroundColor: "var(--mexx-green-primary)",
    cursor: "pointer",
    border: "none",
    outline: "none", // Remove o outline ao clicar
  },
  card: {
    marginBottom: "16px",
    border: "1px solid #e2e8f0",
    borderRadius: "4px",
    backgroundColor: "#fff",
  },
  cardContent: {
    padding: "16px",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  cardTitle: {
    fontWeight: "bold",
    color: "#2c3e50",
    fontSize: "16px",
    cursor: "pointer",
  },
  cardCondition: {
    fontSize: "14px",
    color: "#718096",
    marginTop: "8px",
  },
  cardActions: {
    display: "flex",
    alignItems: "center",
  },
  switchContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "48px",
    height: "24px",
    borderRadius: "999px",
    padding: "4px",
    cursor: "pointer",
  },
  switchActive: {
    backgroundColor: "#48bb78",
  },
  switchInactive: {
    backgroundColor: "#cbd5e0",
  },
  switchKnob: {
    backgroundColor: "#fff",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    transition: "transform 300ms ease-in-out",
    position: "relative",
  },
  switchKnobActive: {
    transform: "translateX(24px)",
  },
  switchIcon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  menuButton: {
    marginLeft: "8px",
    padding: "4px",
    color: "#718096",
    border: "none",
    background: "none",
    cursor: "pointer",
    outline: "none", // Remove o outline ao clicar
  },
  cardDivider: {
    borderTop: "1px solid #e2e8f0",
  },
  cardFooter: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 16px",
    backgroundColor: "#f8fafc",
    fontSize: "14px",
    color: "#718096",
  },
  actionMenu: {
    position: "absolute",
    backgroundColor: "#fff",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    borderRadius: "4px",
    zIndex: 50,
    minWidth: "180px",
  },
  menuList: {
    padding: "4px 0",
  },
  menuItem: {
    padding: "8px 16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
  },
  menuItemHover: {
    backgroundColor: "#f7fafc",
  },
  menuText: {
    fontSize: "14px",
  },
  deleteMenuItem: {
    color: "#e53e3e",
  },
  emptyContainer: {
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "4px",
    padding: "24px",
    textAlign: "center",
  },
  emptyText: {
    color: "#718096",
  },
};

export default styles;
